import { SortFn } from "../../helper/sort";

function getSignalData(signals) {
  if (!signals || !signals.length || signals.length < 3) {
    return signals || [];
  }

  let data = [];
  const _groupNames = [...new Set(signals.map(item => item.signalGroup).filter(item => !!item))]
  data = SortFn(signals, _groupNames, 'signalGroup');
  let currGroup = null;
  let newData = []
  for (let item of data) {

    if (currGroup !== item.signalGroup && item.signalGroup) {
      currGroup = item.signalGroup;
      newData.push({
        ...item,
        groupLength: data.filter(it => it.signalGroup === item.signalGroup).length
      })
      continue;
    } else if (item.signalGroup) {
      newData.push({
        ...item,
        groupLength: 0
      })
      continue;
    }
    newData.push({
      ...item,
      groupLength: 1
    })
  }
  return newData;
}

/**
 * 
 * @param {*} Interfaces [{}]
 * @param {*} signals [{}]
 * @param {string} signalName 
 */
function getMasterCompOptions(Interfaces, signals, signalName) {
  try {
    const currentSignals = signals.filter(item => item.name === signalName);
    const currentPcbId = currentSignals.map(item => item.pcbId);
    const currentInterfaces = Interfaces.filter(item => currentPcbId.includes(item.pcbId));

    const masterCompOptions = currentInterfaces.map(item => {
      const { pcb, content, } = item;
      const components = content.components.filter(it => it.type === "IC" && it.pins.find(pin => pin.signal === signalName));
      return {
        group: pcb,
        children: components.map(comp => ({ id: `${comp.name}::${item.pcbId}`, title: comp.name }))
      }
    })

    return masterCompOptions.length > 1 ? masterCompOptions : masterCompOptions[0] && masterCompOptions[0].children ? masterCompOptions[0].children.map(it => it.title) : [];
  } catch (error) {
    return [];
  }
}

export {
  getSignalData,
  getMasterCompOptions
}